import { SxProps } from '@mui/system';

import { useTheme } from '@mui/material/styles';

import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';

import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/ChevronLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/ChevronRight';

interface LeftPanelProps {
  open: boolean;
  openedWidth: number;
  closedWidth: number;
  title?: React.ReactElement;
  children?: React.ReactElement;
  onClick?: (event: React.MouseEvent) => void;
  sx?: SxProps;
  hideHeader?: boolean;
}

function LeftPanel(props: LeftPanelProps) {
  const {
    open,
    openedWidth,
    closedWidth,
    title,
    children,
    onClick,
    sx,
    hideHeader,
  } = props;

  const theme = useTheme();

  return (
    <Paper
      square
      elevation={2}
      sx={{
        zIndex: theme.zIndex.appBar - 1,
        position: 'relative',
        minWidth: openedWidth,
        transition: 'margin 150ms',
        marginLeft: open ? 0 : `-${openedWidth - closedWidth}px`,
        ...sx,
      }}
    >
      {!hideHeader && (
        <Stack
          direction="row"
          alignItems="center"
          sx={{
            pt: { xs: 1, sm: 0.5, md: 0.5, lg: 1.5, xl: 1.5 },
            pr: 1,
            pl: 2,
          }}
        >
          <Stack direction="row" flexGrow={1} alignItems="center">
            {title}
          </Stack>
          <IconButton onClick={onClick}>
            {open ? (
              <KeyboardDoubleArrowLeftIcon />
            ) : (
              <KeyboardDoubleArrowRightIcon />
            )}
          </IconButton>
        </Stack>
      )}
      {children}
    </Paper>
  );
}

export { LeftPanel };
export type { LeftPanelProps };
